import {
    Component, HostListener,
    OnInit,
} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap";
import {Subject} from "rxjs";

@Component({
    selector: 'app-task-detail-images',
    templateUrl: './view-task-detail-images.component.html',
    styleUrls: ['view-task-detail-images.component.scss'],
})
export class ViewTaskDetailImagesComponent implements OnInit {
    onClose: Subject<any>;
    photos: any[];
    selectedIndex: number;
    selectedPhoto: any;

    constructor(
        public bsModalRef: BsModalRef,
    ) {}

    ngOnInit() {
        this.selectedPhoto = this.photos[this.selectedIndex];
    }

    close() {
        this.bsModalRef.hide();
    }

    @HostListener('window:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent): void {
        if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
            this.showNextImage();
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
            this.showPreviousImage();
        }
    }

    showNextImage(): void {
        if (this.selectedIndex < this.photos.length - 1) {
            this.selectedIndex++;
            this.selectedPhoto = this.photos[this.selectedIndex];
        }
    }

    showPreviousImage(): void {
        if (this.selectedIndex > 0) {
            this.selectedIndex--;
            this.selectedPhoto = this.photos[this.selectedIndex];
        }
    }


}
